/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mean_Alive_Hound_GrinInputs */

const fr_mean_alive_hound_grin = /** @type {(inputs: Mean_Alive_Hound_GrinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer les notifications sur ce navigateur`)
};

/**

* @param {Mean_Alive_Hound_GrinInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mean_alive_hound_grin = /** @type {((inputs?: Mean_Alive_Hound_GrinInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mean_Alive_Hound_GrinInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mean_alive_hound_grin(inputs)
});